import { useTranslation } from 'react-i18next';
import { MinimumOrderValue } from '../common/state/state';
import { formatMinimumOrderValue } from '../common/utils/common.utils';
import { SocialTag } from '../common/utils/social-tags.utils';
import { GeoLoc } from '../common/models/user.models';
import CompanyCategoryTag from './CompanyCategoryTag';

export interface CompanySocialTagsSubtitleProps {
  tags: SocialTag[];
  geoloc: GeoLoc;
  isWholesaler?: boolean;
  minimumOrderValue?: MinimumOrderValue;
}

export default function CompanySocialTagsSubtitle({ tags, geoloc, isWholesaler, minimumOrderValue }: CompanySocialTagsSubtitleProps): React.JSX.Element {
  const { t } = useTranslation(['packaging', 'social-proof']);

  return (
    <>
      <CompanyCategoryTag
        isWholesaler={isWholesaler}
        targetGeoLoc={geoloc}
        variant="text"
      />
      {!!tags.length && (
        <>
          &nbsp;- {tags.map(({ type }) => t(`social-proof:${type.toLowerCase()}.title`)).join(' - ')}
        </>
      )}
      {minimumOrderValue && (
        <>&nbsp;- {formatMinimumOrderValue(t, minimumOrderValue.value, minimumOrderValue.type)} {t('common:minimum_abbr')}</>
      )}
    </>
  );
}
